import React from "react";
import "./App.scss";
import AnimatedRoutes from "./routes/AnimatedRoutes";

function App() {
  return <AnimatedRoutes />;
}

export default App;
